module.exports = __webpack_public_path__ + "img/progress-1.b8a4b734.png";